export default "__VITE_ASSET__CsJD4R7i__"